export const MIN_STAKE_CENTS = 500;
export const MAX_STAKE_CENTS = 1000000;

export const STAKE_OPTION_VALUES_CENTS = [
  500, 1000, 1500, 2000, 3000, 5000, 7000, 10000, 15000, 20000, 30000, 50000,
  70000, 100000, 150000, 200000, 300000, 500000, 700000, 1000000,
] as const;

export function resolveStakeSelectionInitialStake(params: {
  initialStake?: number;
  stakeCapCents: number;
  userBalance: number;
}): number {
  const maxAllowedStakeCents = Math.min(params.stakeCapCents, MAX_STAKE_CENTS);
  const enabledOptions = STAKE_OPTION_VALUES_CENTS.filter(
    (option) => option <= maxAllowedStakeCents,
  );

  if (enabledOptions.length === 0) {
    return MIN_STAKE_CENTS;
  }

  if (
    typeof params.initialStake === 'number' &&
    Number.isFinite(params.initialStake) &&
    enabledOptions.includes(
      params.initialStake as (typeof enabledOptions)[number],
    )
  ) {
    return params.initialStake;
  }

  const maxAffordableOption = enabledOptions.filter(
    (option) => option <= params.userBalance,
  );

  return maxAffordableOption[maxAffordableOption.length - 1] ?? MIN_STAKE_CENTS;
}
